export const ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT =
  'ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT'
export const ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_PENDING =
  'ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_PENDING'
export const ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_FULFILLED =
  'ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_FULFILLED'
export const ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_REJECTED =
  'ONBOARDING_ORGANIZATION_TRACKING_STEPS_PUT_REJECTED'
